import { createContext } from '@lit/context'
export type NavbarPart = 'mobile' | 'desktop'
export const navbarContext = createContext<NavbarPart>('')
